import React, { useContext } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { SALES_FILE_TYPE_IDS } from 'globals.js';

// HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import Card from '../parts/Card';
import Attachment from 'routers/interface/tools/attachment/Attachment';

// MAIN COMPONENT
const RebateAttachmentsForm = () => {
  const { refetchRecord } = useContext(RecordContext);

  const { values: { aryRebate = [], sale_type_category_code, inventory } = {} } = useFormikContext() || {};
  const { new_used } = inventory || {};

  const documentType = {
    0: {
      RETAIL: SALES_FILE_TYPE_IDS.REBATE_RETAIL_USED,
      WHOLESALE: SALES_FILE_TYPE_IDS.REBATE_WHOLESALE_USED
    },
    1: {
      RETAIL: SALES_FILE_TYPE_IDS.REBATE_RETAIL_NEW,
      WHOLESALE: SALES_FILE_TYPE_IDS.REBATE_WHOLESALE_NEW
    }
  };

  return (
    <Form.Body>
      {aryRebate.map((r, i) => {
        if (r.require_customer_signature_upload) {
          return (
            <Attachment.Upload
              key={i}
              label={`Customer Sig Docs for ${r.item_name || 'unknown'}`}
              name={`aryRebate[${i}].aryCustSigRebateAttachment`}
              documentType={documentType?.[new_used]?.[sale_type_category_code]}
              uploadType="sales"
              uploadParams={{
                salesRebateId: r.sales_rebate_id
              }}
              requestParams={{
                sales_rebate_id: r.sales_rebate_id
              }}
              onComplete={refetchRecord}
            />
          );
        }
        return null;
      })}
    </Form.Body>
  );
};

// EXPORT
export default function RebateAttachments({ number, ...props }) {
  const { record: initialValues = {} } = useContext(RecordContext) || {};

  return (
    <Card
      number={number}
      title="Rebate Program Documents (Customer Signature)"
      color="yellow"
      body={
        <Form initialValues={initialValues}>
          <RebateAttachmentsForm {...props} />
        </Form>
      }
    />
  );
}
